import { Table } from "flowbite-react";
import { formatDocument } from "../../../utils/utils";

const Sociedade = ({ socios, canFormatDocument = true }) => {
  return (
    <>
      <div className="overflow-x-hidden border-gray-100 border rounded-lg mt-3">
        <Table striped>
          <Table.Head className="text-black">
            <Table.HeadCell
              className="text-center py-2 px-1"
              style={{ background: "#EBF5FF" }}
            >
              Nº
            </Table.HeadCell>
            <Table.HeadCell className="py-2" style={{ background: "#EBF5FF" }}>
              Nome
            </Table.HeadCell>
            <Table.HeadCell
              className="text-center py-2 px-1"
              style={{ background: "#EBF5FF" }}
            >
              CPF
            </Table.HeadCell>
            <Table.HeadCell
              className="text-center py-2 px-1"
              style={{ background: "#EBF5FF" }}
            >
              Cargo
            </Table.HeadCell>
            <Table.HeadCell
              className="text-center py-2 px-1"
              style={{ background: "#EBF5FF" }}
            >
              Part. (%)
            </Table.HeadCell>
            <Table.HeadCell
              className="text-center py-2 px-1"
              style={{ background: "#EBF5FF" }}
            >
              Restrição
            </Table.HeadCell>
          </Table.Head>
          {socios?.length > 0 && (
            <Table.Body className="divide-y">
              {socios?.map((socio, index) => (
                <Table.Row
                  key={index}
                  className="bg-white dark:border-gray-700 dark:bg-gray-800 text-black"
                >
                  <Table.Cell className="font-medium dark:text-white text-center py-2 px-1">
                    {index + 1}
                  </Table.Cell>
                  <Table.Cell className=" py-1">
                    <div>{socio?.nome || "-"}</div>
                  </Table.Cell>
                  <Table.Cell className="text-center py-1 px-1">
                    {socio?.cpf
                      ? canFormatDocument
                        ? formatDocument(socio?.cpf)
                        : socio?.cpf
                      : "-"}
                  </Table.Cell>
                  <Table.Cell className="text-center py-1 px-1">
                    {socio?.cargo || "-"}
                  </Table.Cell>
                  <Table.Cell className="text-center py-1 px-1 px-1">
                    {socio?.participacaoEmPorcentagem ||
                      socio?.percentualParticipacao ||
                      "-"}
                  </Table.Cell>
                  <Table.Cell className="text-center py-1 px-1 px-1">
                    {socio?.temRestricoes == null
                      ? "-"
                      : socio.temRestricoes
                      ? "Sim"
                      : "Não"}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          )}
        </Table>
      </div>
    </>
  );
};

export default Sociedade;
